/* eslint-disable */
import { FILTER_ADDRESS_REMOVED_ALL } from '../Filters.types';

/**
 * Action to remove the addresses from the filters
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ADDRESS_REMOVED_ALL>>} The created `Action`
 */
const filtersRemoveAllAddresses = () => ({ fromPayload }) => {
  return fromPayload(null, { debounce: true }, FILTER_ADDRESS_REMOVED_ALL);
};

export default filtersRemoveAllAddresses;
